import { TableColumn } from "../../../components/common/Table/Table";

export const columnsDetail: TableColumn[] = [
  { key: "id", label: "ID", className: "md:max-w-[10rem] md:min-w-[5rem]" },
  {
    key: "ubtName",
    label: "Name of UBT",
    className: "md:max-w-[11rem] md:min-w-[5rem]",
  },
  {
    key: "dateTeamEstablished",
    label: "Date team established",
    className: "md:max-w-[8rem] md:min-w-[5rem]",
  },
  {
    key: "teamRating",
    label: "Team rating",
    className: "md:max-w-[11rem] md:min-w-[5rem]",
  },
  {
    key: "serviceType",
    label: "Service type",
    className: "md:max-w-[11rem] md:min-w-[5rem]",
  },
  {
    key: "usingHuddles",
    label: "Using huddles",
    className: "md:max-w-[8rem] md:min-w-[5rem]",
  },
  {
    key: "defaultMembership",
    label: "Default membership",
    className: "md:max-w-[8rem] md:min-w-[5rem]",
  },
  { key: "edit", label: "Edit", className: "md:max-w-[6rem] md:min-w-[5rem]" },
];

export const defaultedMembersColumns: TableColumn[] = [
  {
    key: "lastName",
    label: "Last Name",
    className: "md:max-w-[11rem] md:min-w-[5rem]",
    isSortable: true,
  },
  {
    key: "firstName",
    label: "First Name",
    className: "md:max-w-[11rem] md:min-w-[5rem]",
    isSortable: true,
  },
  { key: "nuid", label: "NUID", className: "md:max-w-[9rem] md:min-w-[5rem]" },
  {
    key: "unionCode",
    label: "Union Code",
    className: "md:max-w-[11rem] md:min-w-[5rem]",
  },
  { key: "ckpu", label: "CKPU", className: "md:max-w-[11rem] md:min-w-[5rem]" },
  { key: "teamRole", label: "Team Role", className: "md:min-w-[11rem]" },
];

export const addMembersColumn: TableColumn[] = [
  {
    key: "lastName",
    label: "Last Name",
    className: "md:max-w-[11rem] md:min-w-[5rem]",
    isSortable: true,
  },
  {
    key: "firstName",
    label: "First Name",
    className: "md:max-w-[11rem] md:min-w-[5rem]",
    isSortable: true,
  },
  { key: "nuid", label: "NUID", className: "md:max-w-[9rem] md:min-w-[5rem]" },
  {
    key: "location",
    label: "Location",
    className: "md:max-w-[9rem] md:min-w-[5rem]",
  },
  {
    key: "unionCode",
    label: "Union Code",
    className: "md:max-w-[11rem] md:min-w-[5rem]",
  },
  { key: "ckpu", label: "CKPU", className: "md:max-w-[11rem] md:min-w-[5rem]" },
  {
    key: "action",
    label: "Action",
    className: "md:max-w-[11rem] md:min-w-[5rem]",
  },
];

export const columnsInfo: TableColumn[] = [
  {
    key: "glString",
    label: "GL string",
    className: "md:max-w-[10rem] md:min-w-[5rem]",
  },
  {
    key: "entity",
    label: "Entity",
    className: "md:max-w-[11rem] md:min-w-[5rem]",
  },
  {
    key: "location",
    label: "Location",
    className: "md:max-w-[9rem] md:min-w-[5rem]",
  },
  {
    key: "costCenter",
    label: "Cost Center",
    className: "md:max-w-[11rem] md:min-w-[5rem]",
  },
  {
    key: "shift",
    label: "Shift",
    className: "md:max-w-[11rem] md:min-w-[5rem]",
  },
  {
    key: "employees",
    label: "#Employees",
    className: "md:max-w-[8rem] md:min-w-[5rem]",
  },
];

export const columnsSummary: TableColumn[] = [
  {
    key: "ubtMembershipSummary",
    label: "UBT membership summary",
    className: "md:max-w-[11rem] md:min-w-[5rem]",
  },
  {
    key: "defaulted",
    label: "Defaulted",
    className: "md:max-w-[9rem] md:min-w-[5rem]",
  },
  {
    key: "manuallyAdded",
    label: "Manually added",
    className: "md:max-w-[11rem] md:min-w-[5rem]",
  },
  {
    key: "total",
    label: "Total",
    className: "md:max-w-[11rem] md:min-w-[5rem]",
  },
];
